import React from 'react';
import {Outlet} from 'react-router-dom';
import ErrorToast from '@/views/content-studio/components/error-toast/ErrorToast';

function ErrorToastRoute() {
  return (
    <>
      <Outlet />
      <ErrorToast />
    </>
  );
}

export default ErrorToastRoute;
